function mapReviewPhotos(photos) {
  return photos.map(({ sizes: { thumbnail, normal } }) => ({
    thumbnailUrl: thumbnail.url,
    fullSizeUrl: normal.url,
  }));
}

export function reviewMapper(result) {
  const {
    id,
    rating,
    title,
    reviewText,
    submissionRecency,
    syndicationSource,
    badgesOrder,
    badges,
    photos = [],
  } = result;

  return {
    id,
    rating,
    title,
    reviewText,
    submissionRecency,
    syndicationSource,
    badgesOrder,
    badges,
    photos: mapReviewPhotos(photos),
  };
}
